import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { Icon } from '@ui/Icon';

export const ListSearchButton = ({
  onClick,
  tooltip = 'Search',
}: {
  onClick: () => void;
  tooltip?: string;
}) => (
  <Tooltip title={tooltip} placement="bottom" disableInteractive>
    <Box
      component="button"
      type="button"
      aria-label={tooltip}
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        px: '6px',
        py: 0,
        m: 0,
        flexShrink: 0,
        border: 'none',
        background: 'none',
        color: 'inherit',
        font: 'inherit',
        opacity: 0.6,
        cursor: 'pointer',
        '&:hover': { opacity: 1 },
      }}
    >
      <Icon category="mui" icon="Search" size={12} />
    </Box>
  </Tooltip>
);
